module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="frame" class="swiper-container ' +
((__t = ( getLayoutClass() )) == null ? '' : __t) +
'">\n    <div class="swiper-wrapper"></div>\n    <div class="swiper-pagination"></div>\n</div>\n<p class="screen_reader_only">' +
((__t = ( I18n.t('widget.screen_reader_only.carousel.slide_controls') )) == null ? '' : __t) +
'</p>\n<p class="screen_reader_only" id="controls_description">' +
((__t = ( I18n.t('widget.screen_reader_only.carousel.slide_controls_description') )) == null ? '' : __t) +
'</p>\n<div class="controls" aria-describedby="controls_description">\n    <div class="swiper-button-next btn next" tabindex="0" role="button" aria-label="' +
((__t = ( I18n.t('common.controls.carousel_next') )) == null ? '' : __t) +
'" aria-disabled="false"></div>\n    <div class="swiper-button-prev btn prev" tabindex="0" role="button" aria-label="' +
((__t = ( I18n.t('common.controls.carousel_previous') )) == null ? '' : __t) +
'" aria-disabled="false"></div>\n</div>';

}
return __p
}